export default __webpack_public_path__ + "static/media/qhacksCrown-colored.387d3e01.svg";